// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__wDJUp","item":"PaymentsMobile_item__3ltZH","label":"PaymentsMobile_label__33py-","amount":"PaymentsMobile_amount__1iSII"};